import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksDa = () => {
    return <HowStartpageWorks languageCode="da" />
}

export default HowStartpageWorksDa
